import { colors, IconArrowDown } from '@fortum/elemental-ui';
import React from 'react';
import { Namespace, useTranslation } from 'react-i18next';

export const SkipToContentLink: React.FC = () => {
  const { t } = useTranslation<Namespace>('glossary');
  return (
    <a
      href="#main-content"
      style={{
        position: 'absolute',
        top: '8px',
        left: '8px',
        backgroundColor: colors.ivyGreen600,
        color: colors.snowWhite,
        padding: '8px 12px',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        zIndex: 9999,
        transform: 'translateY(-200%)',
        transition: 'transform 0.3s ease',
        fontSize: '18px',
        outline: 'none',
        textDecoration: 'none',
        fontFamily: "'FortumSans', Arial, sans-serif",
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
      }}
      onFocus={e => {
        const el = e.target as HTMLElement;
        el.style.transform = 'translateY(0)';
        el.style.outline = `2px solid ${colors.broadBlue700}`;
        el.style.outlineOffset = '2px';
      }}
      onBlur={e => {
        const el = e.target as HTMLElement;
        el.style.transform = 'translateY(-200%)';
        el.style.outline = 'none';
      }}
      onKeyDown={e => {
        if (e.code === 'Space' || e.key === ' ') {
          e.preventDefault();
          (e.target as HTMLElement).click();
        }
      }}
    >
      {t('accessibility.skipToMain')}
      <IconArrowDown aria-hidden size={24} />
    </a>
  );
};
